const ignoredErrorMessages = [
  'AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows',
];

export const configureHandlers = (app, flashesStore) => {
  app.config.errorHandler = (err) => {
    // handle errors when new build is deployed and user is actively using the app
    // certain chunks won't be available and the user will need to reload the app
    if (err && err.toString().includes('ChunkLoadError')) {
      flashesStore.addInfoFlash({
        message: '🎉 Application Update Available',
        description: 'Get the latest and greatest Crossbeam by',
        link: {
          url: window.location.href,
          text: 'refreshing now',
        },
      });
    }

    // handle expired sessions
    if (err && err.toString().includes('Session has expired.')) {
      window.location.replace('/login');
      return;
    }

    if (
      err &&
      window.location.pathname !== '/login' &&
      err?.response?.status === 401
    ) {
      flashesStore.addErrorFlash({
        message: 'Session has expired.',
        description: 'Please re-enter login credentials.',
      });
      window.location.replace('/login');

      return;
    }

    if (!ignoredErrorMessages.some((msg) => err?.message?.startsWith(msg))) {
      console.error(err);
      // This gets run in a timeout because otherwise, infinite loop issues may
      // sometimes occur. I haven't figured out the exact mechanism, but my
      // theory is that:
      //  1 Vue tries to render a component, where an error occurs
      //  2 This error handler runs and updates the pinia store
      //  3 The change to the pinia store causes Vue to try to re-render the
      //    component
      //  4 Go back to step 1
      // Some resources on this behavior:
      // - https://github.com/vuejs/vuex/issues/1505
      // - https://github.com/vuejs/vue/pull/9489
      setTimeout(() => {
        flashesStore.addUnhandledError(err);
      });
    }
  };
};

export const captureException = (err) => {
  const customError = new Error();

  // muncher sends errors property as an array of strings
  if (Array.isArray(err?.errors) && err.errors.length > 0) {
    customError.message = err.errors.join(', ');
  }
  // include error message from axios request if the exception is from an axios request
  else if (err.response?.data && err.message) {
    const responseMessage = JSON.stringify(err.response?.data);
    customError.message = `${err.message}: ${responseMessage}`;
  } else {
    // fallback to original error message
    customError.message = err.message ?? 'Unknown error';
  }

  if (import.meta.env.MODE !== 'test') {
    console.error('exception reported', customError);
  }

  // returning for testing
  return customError;
};

export const defaultErrorMessage =
  'Something went wrong, reach out to our support team for help';

export default {
  captureException,
  defaultErrorMessage,
};
